module.exports = __webpack_public_path__ + "fonts/Muli-Regular.8ec7d4e4.eot";